module.exports = __webpack_public_path__ + "img/banner_ratinho_acerte_aqui.3ddf3fed.png";